import { RatingOptions } from "@/components/Common/GuidedVideoCall/Steps/QuestionsStep";

export const getPatientOutcomeRatings = (
  ratingOptionLabelMap,
  answer,
  ratingAnswerOnClick,
  isDisabled = false,
  formikProps = {},
) => {
  return (
    <>
      <div className="d-flex justify-content-between">
        {Object.values(ratingOptionLabelMap).map((optionLabel) => (
          <div className="w-100 text-center fs-12 tw:font-bold" key={optionLabel}>
            {optionLabel}
          </div>
        ))}
      </div>

      <RatingOptions
        disabled={isDisabled}
        optionLabelMap={ratingOptionLabelMap}
        optionStyle={{ height: 15 }}
        optionWrapperStyle={{ margin: "0px 5px" }}
        questionData={{ answer: answer }}
        questionId="patient_outcome"
        questionSet="patient_outcome"
        ratingAnswerOnClick={(questionSet, questionId, optionId) =>
          ratingAnswerOnClick(questionSet, questionId, optionId, formikProps)
        }
      />
    </>
  );
};
